import React, {useState, useEffect} from 'react';
import OaCard from 'oahoc/OaCard';
import OaTabBar from 'oahoc/OaTabBar';
import {getQueryVar, getCurrentTab, getAgencyId } from 'oautils/oaCommonUtils.js';
import AgentDetails from 'pages/agent/AgentDetails';
import CommissionEditForm from 'pages/management/commission-and-markup/flight/CommissionEditForm';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

const CommissionAgentEdit = (props) => {
    const history = useHistory();
    /*
    console.log(props.match.params.priTab);
    console.log(props.match.params.agencyId);
    console.log(history.location.row.data);
    */
    //console.log(JSON.stringify(props));
    //props = JSON.parse('{"history":{"length":5,"action":"PUSH","location":{"pathname":"/admin/management/commission/edit/flight/domestic/952","row":{"data":{"uId":2194,"cId":372722,"actualDiscount":0,"destination":"All Sectors","origin":"All Sectors","carrierName":"Indigo","bookingClass":"","classException":"","originException":"","destinationException":"","percentageDiscountBasic":0,"percentageDiscountGross":0.5,"startDate":"09-08-2019 00:00","endDate":"31-03-2020 23:59","actualDiscountCodeShare":0,"fixedDiscount":"1.0% (Basic+YQ)","variableDiscount":"","commissionType":"P","p_discount_basic_codeshare":0,"p_discount_gross_codeshare":0,"A_Discount_codeshare":0,"A_Amount":0,"our_share":0,"CP_Discount":0,"Cp_discount_basic":0,"Cp_discount_gross":2,"CA_Discount":0,"CA_Amount":0,"Cdsa_share":0,"Cp_discount_basic_codeshare":0,"Cp_discount_gross_codeshare":0,"CA_Discount_codeshare":0,"dsaShare":0,"TP_Discount":0,"Tp_discount_basic":0,"Tp_discount_gross":1,"TA_Discount":0,"TA_Amount":0,"Tdsa_share":0,"Tp_discount_basic_codeshare":0,"Tp_discount_gross_codeshare":0,"TA_Discount_codeshare":0,"agentDiscountId":944}},"search":"","hash":"","key":"uvm3wo"}},"location":{"pathname":"/admin/management/commission/edit/flight/domestic/952","row":{"data":{"uId":2194,"cId":372722,"actualDiscount":0,"destination":"All Sectors","origin":"All Sectors","carrierName":"Indigo","bookingClass":"","classException":"","originException":"","destinationException":"","percentageDiscountBasic":0,"percentageDiscountGross":0.5,"startDate":"09-08-2019 00:00","endDate":"31-03-2020 23:59","actualDiscountCodeShare":0,"fixedDiscount":"1.0% (Basic+YQ)","variableDiscount":"","commissionType":"P","p_discount_basic_codeshare":0,"p_discount_gross_codeshare":0,"A_Discount_codeshare":0,"A_Amount":0,"our_share":0,"CP_Discount":0,"Cp_discount_basic":0,"Cp_discount_gross":2,"CA_Discount":0,"CA_Amount":0,"Cdsa_share":0,"Cp_discount_basic_codeshare":0,"Cp_discount_gross_codeshare":0,"CA_Discount_codeshare":0,"dsaShare":0,"TP_Discount":0,"Tp_discount_basic":0,"Tp_discount_gross":1,"TA_Discount":0,"TA_Amount":0,"Tdsa_share":0,"Tp_discount_basic_codeshare":0,"Tp_discount_gross_codeshare":0,"TA_Discount_codeshare":0,"agentDiscountId":944}},"search":"","hash":"","key":"uvm3wo"},"match":{"path":"/admin/management/commission/edit/flight/:priTab/:agencyId","url":"/admin/management/commission/edit/flight/domestic/952","isExact":true,"params":{"priTab":"domestic","agencyId":"952"}}}');

    const [currentTab, setCurrentTab] = useState('commissions');
    const [agencyId, setAgencyId] = useState(getAgencyId(props));
    let baseUrl = '/admin/management/commission/agent/flight/';
    const getAgencyIdUrl = agencyId => {
        return agencyId === undefined ? '' : agencyId;
    }
    let agencyIdUrl = getAgencyIdUrl(agencyId);
    let tabs = [
        { name: 'commissions', label: 'Commission', url: baseUrl + props.match.params.priTab +'/' + agencyIdUrl},
    ];


    return (
        <OaCard className={'oa-card-primary'}>
        <OaTabBar tabs={tabs} currentTab={currentTab} type='primary'/>
        {agencyId && 
            (
                <OaCard>
                    <AgentDetails agencyId={agencyId} />
                </OaCard>
            )
        }
        <OaCard>
               <CommissionEditForm 
                    initialParams={history.location.row.data}
                    requestFlag={props.match.params.priTab}
                    agencyId={agencyId}
                    setIsLoading={false}
                />
        </OaCard>
    </OaCard>

    )
}

export default CommissionAgentEdit;
